import { Injectable } from '@angular/core';
import { RestService } from './rest.service';
import { CodeLinkageSettingsModel } from '../Models/code-linkage-settings-model';

@Injectable({
  providedIn: 'root'
})
export class TemplateServiceService {

  constructor(private rest:RestService) { }

  public getAllProjectList(): any {
    return this.rest.get("project","");

  }

  public getOrganisationByUserName(currentUser:string): any{
    return this.rest.get("getOrgByUserName",currentUser);
  }

  public addCodeLinkageFieldsForProject(projectId: any,CodeLinkageSettings: CodeLinkageSettingsModel): any{
    const id = projectId.$oid ? projectId.$oid : projectId;
    return this.rest.put('addCodeLinkageFieldsForProject',CodeLinkageSettings,id);
  }
  public addCodeLinkageFieldsForOrg(orgId: any,CodeLinkageSettings: CodeLinkageSettingsModel): any{
    const id =orgId.$oid ? orgId.$oid : orgId;
    return this.rest.put('addCodeLinkageFieldsForOrg',CodeLinkageSettings,id);
  }
}
